import { authClientId, authClientSecret } from "../config/config";
import { DataRegister, DataLogin, DataForgotPassword, DataResetPassword, DataUpdateProfile } from "./user.type";
import axios from 'axios';

// Create new user account.
function registerApi(data: DataRegister) {
    return axios({
        method: 'post',
        url: '/api/v1/users/register',
        data: data
    });
}

// Create new user account.
function registerWithValidationApi(data: DataRegister) {
    return axios({
        method: 'post',
        url: `/api/v1/users/register/${data.email}`,
        data: data
    });
}


// Request user credentials.
async function loginApi(data: DataLogin) {
    return axios({
        method: 'post',
        url: '/oauth/v2/token',
        data: {
            ...data,
            grant_type: 'password',
            client_id: authClientId,
            client_secret: authClientSecret
        }
    });
}

// Show logged user details.
async function getMeInfoApi() {
    return axios({
        method: 'get',
        url: '/api/v1/me',
    });
}

// Logout user.
async function logoutApi() {
    return axios({
        method: 'DELETE',
        url: '/api/v1/logout'
    });
}

// User forgot password reset link.
function forgotPasswordApi(data: DataForgotPassword) {
    return axios({
        method: 'POST',
        url: '/api/v1/users/forgot-password',
        data: data
    });
}

// User reset password with link.
function resetPasswordApi(code: string, data: DataResetPassword) {
    return axios({
        method: 'POST',
        url: `/api/v1/users/reset-password/${code}`,
        data: data
    });
}

// Update login user information.
function updateProfileDataApi(data: DataUpdateProfile) {
    return axios({
        method: 'PATCH',
        url: '/api/v1/me',
        data: data
    });
}

export {
    registerApi,
    loginApi,
    getMeInfoApi,
    logoutApi,
    forgotPasswordApi,
    resetPasswordApi,
    updateProfileDataApi,
    registerWithValidationApi
}
